export default __webpack_public_path__ + "static/media/HASSAN_FR_EPILOGFIN1.de82e2a1.mp3";